import { ChartSettingEnum } from "~/feature/chart/types";

export const labelByChartSetting: Record<ChartSettingEnum, string> = {
  [ChartSettingEnum.AUTOSCALE]: "Autoscale",
  [ChartSettingEnum.X_AXIS]: "X-axis",
  [ChartSettingEnum.Y_AXIS]: "Y-axis",
  [ChartSettingEnum.HORIZONTAL_GRID]: "Horizontal grid",
  [ChartSettingEnum.VERTICAL_GRID]: "Vertical grid",
  [ChartSettingEnum.VOLUME]: "Volume",
  [ChartSettingEnum.NEWS]: "News annotations",
};

export const chartSettingsTitle = "Chart settings";
